import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MdOutlineNotificationAdd } from 'react-icons/md';
import { FaAngleDown } from 'react-icons/fa6';
import axios from 'axios';
import { LuUserRound } from "react-icons/lu";
import { RiCoupon3Fill } from "react-icons/ri";
import { TbReportSearch } from "react-icons/tb";
import { BsQuestionCircle } from "react-icons/bs";
import { AiOutlineSetting } from "react-icons/ai";
import { MdOutlineLogout } from "react-icons/md";
import { SlArrowDown } from "react-icons/sl";
import AddCouponsDashboard from './AddCouponsDashboard';
import MerchantReview from './MerchantReview';
import PickProductsForm from './PickProductsForm';
import Refaral from './UserDashboard/Refaral'
import MerchantSite from './MerchantSite/MerchantSite';
import MerchantLogoForm from './MerchantLogoForm';
import MerchantCollectionsAddForm from './MerchantCollectionsAddForm';
import { AiFillProduct } from "react-icons/ai";
import { GoCrossReference } from "react-icons/go";
import { IoLogoBuffer } from "react-icons/io";
import { MdOutlineCollections } from "react-icons/md";
import { CgWebsite } from "react-icons/cg";
import MerchantPage from './MerchantPage/MerchantPage';
import MerchantRegistration from './MerchantRegistration';
import MerchantRefaral from './MerchantRefaral';
import { BsBank2 } from "react-icons/bs";
import MerchantAccountDetails from './MerchantAccountDetails';
import { TbSelect } from "react-icons/tb";
import SelectSlot from './SelectSlot';

const Dashboard = () => {
  const [details, setDetails] = useState({});
  const [view, setView] = useState('account');
  const [id, setId] = useState("");
  const [login, setLogin] = useState(true)


  useEffect(() => {
    const fetchMerchantDetails = async () => {
      const localMerchant = localStorage.getItem('merchantLogin');
      const googleLogin = localStorage.getItem('googleLogin');

      const loginMerchant = JSON.parse(localStorage.getItem("merchantLogin") || "{}");

      if (googleLogin == "true") {
        // alert(loginMerchant.email)
        // alert(googleLogin)
        axios.post('https://api.bakpoket.com/api/MerchantDetails/Login', {
          userName: loginMerchant.name,
          password: loginMerchant.email,
        })
          .then(async (res) => {
            // console.log(res.data)
            localStorage.setItem('merchantDashboardLogin', JSON.stringify(res.data));
            const mid = res.data?.merchantId || res.data?.id
            setId(mid);
            setLogin(true);
            try {
              const response = await axios.get(`https://api.bakpoket.com/api/MerchantDetails/${mid}`);
              if (response?.data) {
                setDetails(response.data);
                // localStorage.setItem('merchantDetailsFromAPI', JSON.stringify(response.data));
              } else {
                // console.warn("No data from API. Using localStorage fallback.");
                setDetails(res.data);
              }
            } catch (error) {
              console.error("API fetch failed. Using localStorage fallback:", error);
              setDetails(res.data);
            }
          })
          .catch(err => {
            // alert(err)
            setLogin(false)
          })
      }

      if (googleLogin == "false") {
        const parsed = JSON.parse(localMerchant);
        const merchantId = parsed?.merchantId || parsed?.id;
        setId(merchantId);
        try {
          const response = await axios.get(`https://api.bakpoket.com/api/MerchantDetails/${merchantId}`);
          if (response?.data) {
            setDetails(response.data);
            // localStorage.setItem('merchantDetailsFromAPI', JSON.stringify(response.data));
          } else {
            // console.warn("No data from API. Using localStorage fallback.");
            setDetails(parsed);
          }
        } catch (error) {
          console.error("API fetch failed. Using localStorage fallback:", error);
          setDetails(parsed);
        }
      } else {
        const merchantDashboardLogin = localStorage.getItem('merchantDashboardLogin');
        const parsed = JSON.parse(merchantDashboardLogin || "{}");
        const merchantId = parsed?.merchantId || parsed?.id;
        setId(merchantId);
        try {
          const response = await axios.get(`https://api.bakpoket.com/api/MerchantDetails/${merchantId}`);
          if (response?.data) {
            setDetails(response.data);
            // localStorage.setItem('merchantDetailsFromAPI', JSON.stringify(response.data));
          } else {
            // console.warn("No data from API. Using localStorage fallback.");
            setDetails(parsed);
          }
        } catch (error) {
          console.error("API fetch failed. Using localStorage fallback:", error);
          setDetails(parsed);
        }
      }
    };

    fetchMerchantDetails();


  }, [id]);



  return (
    <>{login ? (
      <Wrapper>
        <DashboardHeader>
          <LeftSection>
            <img src="/images/icon.png" alt="Logo" />
            <h1>Merchant Dashboard</h1>
          </LeftSection>
          <RightSection>
            <MdOutlineNotificationAdd className="icon" />
            {/* <p>{details?.merchantName || details?.name || "Merchant"}</p> */}
            <p>
              {(details?.merchantName || details?.name || "Merchant")?.length > 4
                ? (details?.merchantName || details?.name)?.slice(0, 4) + ".."
                : (details?.merchantName || details?.name || "Merchant")
              }
            </p>

            <img src="/images/user-img.png" alt="User" className="user-img" />
            <FaAngleDown className="icon" />
          </RightSection>
        </DashboardHeader>

        <div className="maincard">
          <MainContent>
            <Sidebar>
              <div className="top">
                <p onClick={() => setView('account')}><LuUserRound className="sidebar-icons" />Account Information</p>
                <p onClick={() => setView('coupons')}><RiCoupon3Fill className="sidebar-icons" />Create Coupons</p>
                <p onClick={() => setView('review')}><TbReportSearch className="sidebar-icons" />Review</p>
                <p onClick={() => setView('products')}><AiFillProduct className="sidebar-icons" />Pick Your Products</p>
                <p onClick={() => setView('referral')}><GoCrossReference className="sidebar-icons" />Referral</p>
                <p onClick={() => setView('bankdetails')}><BsBank2 className="sidebar-icons" />Bank Details</p>
                <p onClick={() => setView('selectSlot')}><TbSelect className="sidebar-icons" />Select Slot</p>
                {/* <p onClick={() => setView('sitelogo')}><IoLogoBuffer className="sidebar-icons" />Logo</p> */}
                {/* <p onClick={() => setView('collections')}><MdOutlineCollections className="sidebar-icons" />Collections</p> */}
                <p onClick={() => setView('sitecreation')}><MdOutlineCollections className="sidebar-icons" />Site creation</p>
                <p><CgWebsite className="sidebar-icons" /><a href={`https://bakpoket.com/merchantproductsite/${id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "none" }}>Create Your Product page</a></p>

              </div>
              <div className="bottom">
                <hr style={{ border: '0.5px solid black', opacity: 0.4 }} />
                <p><BsQuestionCircle className="sidebar-icons" />Help</p>
                <p><AiOutlineSetting className="sidebar-icons" />Settings</p>
                <p><MdOutlineLogout className="sidebar-icons" />Log Out</p>
              </div>
            </Sidebar>

            {view === 'account' && (
              <>
                <Content>
                  <Section>
                    <h2>Your Account Details</h2>
                    <StyledTable>
                      <tbody>
                        <tr><td>Label</td><td>Value</td></tr>
                        <tr><td>Email</td><td>{details.email || '-'}</td></tr>
                        <tr><td>Password</td><td>{details.password ? '*'.repeat(details.password.length) : '********'}</td></tr>
                        <tr><td>Phone Number</td><td>{details.mobile || '********'}</td></tr>
                      </tbody>
                    </StyledTable>
                  </Section>

                  <Section>
                    <h2>Recent Activity</h2>
                    <SearchSort>
                      <input placeholder="Search" />
                      <p>Sort By Most Recent<SlArrowDown className="drop-icon" /></p>
                    </SearchSort>
                    <StyledTable>
                      <tbody>
                        <tr>
                          <th className='text-center' style={{color:'#e9ecefee'}}>Name</th><th className='text-center' style={{color:'#e9ecefee'}}>Company</th>
                          <th className='text-center' style={{color:'#e9ecefee'}}>Coupons</th><th className='text-center' style={{color:'#e9ecefee'}}>Cashback%</th><th style={{color:'#e9ecefee'}} className='text-center'>Expire on</th>
                          {/* <th className='text-center'>Status</th> */}
                        </tr>
                        {["Vijay", "Avinash", "Chinna", "John", "Kiran", "Akhil"].map((name, i) => (
                          <tr key={i} className='text-center'>
                            <td className='text-center'>{name}</td><td className='text-center'>Zudio</td>
                            <td className='text-center'>30</td><td className='text-center'>10%</td><td className='text-center'>20 Apr 2025</td>

                            {/* <td className={`${i % 2 === 0 ? 'active' : 'scheduled'} text-center`}>
                              {i % 2 === 0 ? 'Active' : 'Scheduled'}
                            </td> */}

                          </tr>
                        ))}
                      </tbody>
                    </StyledTable>
                  </Section>
                </Content>

                <StatsSection>
                  <StatCard><h3>$10,000</h3><p>Earned this month</p></StatCard>
                  <StatCard><h3>20,000</h3><p>Monthly Visitors</p></StatCard>
                  <StatCard><h3>500</h3><p>Coupons issued</p></StatCard>
                </StatsSection>
              </>
            )}

            {view === 'coupons' && (
              <div style={{ flex: 1, padding: '10px' }}>
                <AddCouponsDashboard />
              </div>
            )}

            {view === 'review' && (
              <div style={{ flex: 1, padding: '10px' }}>
                <MerchantReview />
              </div>
            )}
            {view === 'products' && (
              <div style={{ flex: 1, padding: '10px', }} className='mx-auto'>
                <PickProductsForm />
              </div>
            )}
            {view === 'referral' && (
              <div style={{ flex: 1, padding: '10px'}} className='d-flex align-items-center justify-content-center' >
                <MerchantRefaral />
              </div>
            )}
            {view === 'bankdetails' && (
              <div style={{ flex: 1, padding: '10px'}} className='d-flex align-items-center justify-content-center' >
                <MerchantAccountDetails />
              </div>
            )}
            {view === 'selectSlot' && (
              <div style={{ flex: 1, padding: '5px'}} className='d-flex align-items-center justify-content-center' >
                <SelectSlot />
              </div>
            )}
            {view === 'sitelogo' && (
              <div style={{ flex: 1, padding: '10px', }} className='mx-auto'>
                <MerchantLogoForm />
              </div>
            )}
            {view === 'collections' && (
              <div style={{ flex: 1, padding: '10px', }} className='mx-auto'>
                <MerchantCollectionsAddForm />
              </div>
            )}
            {view === 'sitecreation' && (
              <div style={{ flex: 1, padding: '10px', }} className='mx-auto'>
                <MerchantPage />
              </div>
            )}
          </MainContent>
        </div>
      </Wrapper>
    ) : (
      <Wrapper>
        <DashboardHeader>
          <LeftSection>
            <img src="/images/icon.png" alt="Logo" />
            <h1>Merchant Dashboard</h1>
          </LeftSection>
          <RightSection>
            <MdOutlineNotificationAdd className="icon" />
            <p>Merchant</p>
            <img src="/images/user-img.png" alt="User" className="user-img" />
            <FaAngleDown className="icon" />
          </RightSection>
        </DashboardHeader>

        <MerchantRegistration />
      </Wrapper>

    )}
    </>
  );
};

export default Dashboard;


const Wrapper = styled.section`
  font-family: Arial, sans-serif;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 50px auto;
  border-radius: 30px;
  background-color: #f7f9fb;
  overflow: hidden;
  

  .drop-icon { margin-left: 10px; color: black; }
  .sidebar-icons { font-size: 20px; margin-bottom: 5px; margin-right: 5px; }
  .active { color: rgb(13, 124, 28); }
  .scheduled { color: rgb(27, 29, 116); }
  .maincard { display: flex; flex-wrap: wrap; }

  @media (max-width: 480px) {
    width: 98%;
    margin: 10px auto;
    .sidebar-icons { font-size: 10px; margin-bottom: 0px; margin-right: 5px; }
    .drop-icon { margin-left: 2px; }
  }
  @media (max-width: 720px) {
    width: 98%;
    margin: 10px auto;
    .sidebar-icons { font-size: 10px; margin-bottom: 0px; margin-right: 5px; }
    .drop-icon { margin-left: 2px; }
  }
  @media (max-width: 900px) {
    width: 98%;
    margin: 10px auto;
    .sidebar-icons { font-size: 10px; margin-bottom: 0px; margin-right: 5px; }
    .drop-icon { margin-left: 2px; }
  }
  @media (max-width: 1104px) {
    width: 98%;
    margin: 10px auto;
    .sidebar-icons { font-size: 10px; margin-bottom: 0px; margin-right: 5px; }
    .drop-icon { margin-left: 2px; }
  }
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to right, #2a4157, #ef4766);
  padding: 15px 30px;
  color: #fff;
  @media (max-width: 480px) {
    padding: 7px 15px;
  }
  @media (max-width: 720px) {
    padding: 7px 15px;
  }
  @media (max-width: 900px) {
    padding: 7px 15px;
  }
  @media (max-width: 1104px) {
    padding: 7px 15px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  img { width: 40px; }
  h1 { font-size: 22px; margin: 0; }
  @media (max-width: 480px) {
    gap: 5px;
    img { width: 20px; }
    h1 { font-size: 18px; margin: 0; }
  }
  @media (max-width: 720px) {
    gap: 5px;
    img { width: 20px; }
    h1 { font-size: 18px; margin: 0; }
  }
  @media (max-width: 900px) {
    gap: 5px;
    img { width: 20px; }
    h1 { font-size: 18px; margin: 0; }
  }
  @media (max-width: 1104px) {
    gap: 5px;
    img { width: 20px; }
    h1 { font-size: 18px; margin: 0; }
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  p { margin: 0; font-size: 16px; }
  .user-img { width: 32px; height: 32px; border-radius: 50%; object-fit: cover; }
  .icon { font-size: 22px; cursor: pointer; }
  @media (max-width: 480px) {
    gap: 5px;
    p { font-size: 14px; }
    .icon { font-size: 18px; }
    .user-img { width: 24px; height: 24px; }
  }
  @media (max-width: 720px) {
    gap: 5px;
    p { font-size: 14px; }
    .icon { font-size: 18px; }
    .user-img { width: 24px; height: 24px; }
  }
  @media (max-width: 900px) {
    gap: 5px;
    p { font-size: 14px; }
    .icon { font-size: 18px; }
    .user-img { width: 24px; height: 24px; }
  }
  @media (max-width: 1104px) {
    gap: 5px;
    p { font-size: 14px; }
    .icon { font-size: 18px; }
    .user-img { width: 24px; height: 24px; }
  }
`;

const MainContent = styled.div`
  display: flex;
  flex: 1;
`;

const Sidebar = styled.div`
  padding: 30px 20px;
  background-color: #ef4766;
  width: 220px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .top, .bottom {
    display: flex;
    flex-direction: column;
    gap: 12px;
    p {
      margin: 0;
      font-size: 16px;
      color: white;
      cursor: pointer;
      transition: opacity 0.2s ease;
      &:hover { opacity: 0.8; }
    }
  }

   @media (max-width: 480px) {
        padding: 15px 6px;
        width: 90px;
        .top, .bottom {
            gap: 8px;
            p {
            margin: 0;
            font-size: 7px;
        }
    }
  }

  @media (max-width: 720px) {
    padding: 15px 6px;
      width: 90px;
      .top, .bottom {
          gap: 8px;
          p {
          margin: 0;
          font-size: 7px;
      }
  }
  @media (max-width: 900px) {
    padding: 15px 6px;
      width: 90px;
      .top, .bottom {
          gap: 8px;
          p {
          margin: 0;
          font-size: 7px;
      }
  }
  @media (max-width: 1104px) {
    padding: 15px 6px;
      width: 90px;
      .top, .bottom {
          gap: 8px;
          p {
          margin: 0;
          font-size: 7px;
      }
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 30px;
  @media (max-width: 480px) {
    padding: 15px 5px;
    flex-direction: column;
  }
  @media (max-width: 720px) {
    padding: 15px 5px;
    flex-direction: column;
  }
  @media (max-width: 900px) {
    padding: 15px 5px;
    flex-direction: column;
  }
  @media (max-width: 1104px) {
    padding: 15px 5px;
    flex-direction: column;
  }
`;

const Section = styled.div`
  margin-bottom: 40px;
  h2 { font-size: 20px; margin-bottom: 20px; }
  @media (max-width: 480px) {
    margin-bottom: 20px;
    h2 { font-size: 10px; margin-bottom: 15px;
  }
  @media (max-width: 720px) {
    margin-bottom: 20px;
    h2 { font-size: 10px; margin-bottom: 15px;
  }
  @media (max-width: 900px) {
    margin-bottom: 20px;
    h2 { font-size: 10px; margin-bottom: 15px;
  }
  @media (max-width: 1104px) {
    margin-bottom: 20px;
    h2 { font-size: 10px; margin-bottom: 15px;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  overflow: hidden;
  th, td {
    border-left: none;
    border-right: none;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding: 8px 12px;
    text-align: left;
    font-size: 15px;
    color: #2a4157;
  }
  th {
    color: #000;
    background-color: #646262;
    border-top: none;
    border-bottom: none;
  }

  @media (max-width: 480px) {
    width: 100%;
    margin-bottom: 10px;

    th, td {
    padding: 6px 3px;
    font-size: 5px;
  }
  th {
    color: #000;
    background-color: #646262;
    border-top: none;
    border-bottom: none;
  }
  }
  @media (max-width: 720px) {
    width: 100%;
    margin-bottom: 10px;

    th, td {
    padding: 6px 3px;
    font-size: 8px;
  }
  th {
    color: #000;
    background-color: #646262;
    border-top: none;
    border-bottom: none;
  }
  }
  @media (max-width: 900px) {
    width: 100%;
    margin-bottom: 10px;

    th, td {
    padding: 6px 3px;
    font-size: 8px;
  }
  th {
    color: #000;
    background-color: #646262;
    border-top: none;
    border-bottom: none;
  }
  }
  @media (max-width: 1104px) {
    width: 100%;
    margin-bottom: 10px;

    th, td {
    padding: 6px 3px;
    font-size: 8px;
  }
  th {
    color: #000;
    background-color: #646262;
    border-top: none;
    border-bottom: none;
  }
  }
`;

const SearchSort = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 15px;

  input {
    padding: 8px 12px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  p {
    margin: 0;
    font-size: 14px;
    color: #555;
    background-color: white;
    padding: 5px;
    border: 0.5px solid rgb(67, 67, 68);
    border-radius: 5px;
    width: 170px;
  }

  @media (max-width: 480px) {
    gap: 5px;
    margin-bottom: 4px;
    justify-content: space-between;
    input {
        padding: 2px 3px;
        font-size: 9px;
        border: 1px solid #ccc;
        border-radius: 4px;
        width: 80px;
    }
    p {
        font-size: 6px;
        padding: 5px;
        width: 80px;
    }
  }

  @media (max-width: 720px) {
    gap: 5px;
    margin-bottom: 4px;
    justify-content: space-between;
    input {
        padding: 2px 3px;
        font-size: 9px;
        border: 1px solid #ccc;
        border-radius: 4px;
        width: 80px;
    }
    p {
        font-size: 6px;
        padding: 5px;
        width: 80px;
    }
  }
  @media (max-width: 900px) {
    gap: 5px;
    margin-bottom: 4px;
    justify-content: space-between;
    input {
        padding: 2px 3px;
        font-size: 9px;
        border: 1px solid #ccc;
        border-radius: 4px;
        width: 80px;
    }
    p {
        font-size: 6px;
        padding: 5px;
        width: 80px;
    }
  }
  @media (max-width: 1104px) {
    gap: 5px;
    margin-bottom: 4px;
    justify-content: space-between;
    input {
        padding: 2px 3px;
        font-size: 9px;
        border: 1px solid #ccc;
        border-radius: 4px;
        width: 80px;
    }
    p {
        font-size: 6px;
        padding: 5px;
        width: 80px;
    }
  }
`;

const StatsSection = styled.div`
  margin-top: 90px;
  flex-wrap: wrap;
  @media (max-width: 480px) {
    margin-top: 15px;
  }
  @media (max-width: 720px) {
    margin-top: 15px;
  }
  @media (max-width: 900px) {
    margin-top: 15px;
  }
  @media (max-width: 1104px) {
    margin-top: 15px;
  }
`;

const StatCard = styled.div`
  background-color: #fff;
  padding: 20px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  min-width: 200px;
  text-align: center;
  margin-bottom: 20px;
  margin-right: 30px;
  h3 {
    margin: 0 0 10px;
    font-size: 24px;
    color: #0e0d0d;
  }
  p {
    margin: 0;
    color: #333;
    font-size: 14px;
  }

  @media (max-width: 480px) {
    // min-width: 10px;
    // padding: 7px 0px;
    // margin-right: 0px;
    // h3 {
    //   font-size: 8px;
    //   margin-bottom: 5px;
    // }
    // p {
    //   font-size: 5px;
    // }
    display: none;
  }
  @media (max-width: 720px) {
    min-width: 40px;
    padding: 10px 15px;
    margin-top: 20px;
     margin-right: 10px;
    h3 {
      font-size: 8px;
      margin-bottom: 5px;
    }
    p {
      font-size: 5px;
    }
  }
  @media (max-width: 900px) {
    min-width: 40px;
    padding: 10px 15px;
    margin-top: 20px;
     margin-right: 10px;
    h3 {
      font-size: 9px;
      margin-bottom: 5px;
    }
    p {
      font-size: 7px;
    }
  }
  @media (max-width: 1104px) {
    min-width: 40px;
    padding: 10px 15px;
    margin-top: 20px;
     margin-right: 10px;
    h3 {
      font-size: 10px;
      margin-bottom: 5px;
    }
    p {
      font-size: 8px;
    }
  }
`;